import { Box } from '@theme-ui/components';

import useLocaleWithFallback from '@app/hooks/useLocaleWithFallback';

import type { PricingPage_content_pricing_pages_layout_item_pricing_pages_multi_layout_products_products_id as DirectusProduct } from '../../__generated__/PricingPage';
import type { PricingPageShopProduct_magento2_products_items_Magento2_VirtualProduct as VirtualMagentoProduct } from '../../hook/__generated__/PricingPageShopProduct';
import AddToCartButton from '../AddToCartButton/AddToCartButton';
import Price from '../Price';
import { Content, Picture, Title, Wrapper } from './styles';

interface ProductTileProps {
  directusProduct: DirectusProduct;
  magentoProduct: VirtualMagentoProduct;
  country?: string;
}

const VirtualProductTile = ({
  directusProduct,
  magentoProduct,
}: ProductTileProps) => {
  const { findTranslationByKeyWithFallback } = useLocaleWithFallback();

  const { image, priceRange } = magentoProduct;

  const { title, translations } = directusProduct;
  const content = findTranslationByKeyWithFallback({
    translations,
    key: 'multiproduct_layout_content',
  });

  return (
    <Wrapper>
      <Picture
        data-testid="virtual-product-tile-image"
        src={image?.url ?? undefined}
        alt={image?.label ?? undefined}
      />
      <Title data-testid="virtual-product-tile-title" as="h3">
        {title}
      </Title>

      {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}

      <Box py={10} sx={{ flexGrow: 1 }}>
        <Price price={priceRange} />
      </Box>

      <AddToCartButton product={magentoProduct} quantity={1} />
    </Wrapper>
  );
};

export default VirtualProductTile;
